import React, { useEffect } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line

const TEST = (props) => {
  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/test-overlay/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      return () => props.overlayStore.socketDisconnect();
    }
    //props.userStore.getAccessToken();
  }, []);

  const {
    raised,
    goal,
    donations,
    milestones,
    rewards,
    targets,
    status,
    campaignName,
    polls,
  } = props.overlayStore;

  return (
    <div>
      NAME: {campaignName}
      <br />
      STATUS: {status}
      <br />
      RAISED: {raised}
      <br />
      GOAL: {goal}
      <ul>
        <li>DONATIONS</li>
        {donations
          .slice()
          .reverse()
          .map((donation) => (
            <li key={donation.id}>
              {donation.donor_name} / ${donation.amount.value}
            </li>
          ))}
      </ul>
      <ul>
        <li>MILESTONES</li>
        {milestones.map((milestone) => (
          <li key={milestone.id}>
            {milestone.name} / ${milestone.amount.value}{" "}
          </li>
        ))}
      </ul>
      <ul>
        <li>REWARDS</li>
        {rewards.map((reward) => (
          <li key={reward.id}>
            {reward.name} / ${reward.amount.value} /{" "}
            {reward.highlighted && "highlighted"} / {reward.quantity_remaining}{" "}
            remaining
          </li>
        ))}
      </ul>
      <ul>
        <li>TARGETS</li>
        {targets.map((target) => (
          <li key={target.id}>
            {target.name} / ${target.amount.value} / $
            {target.amount_raised.value}
          </li>
        ))}
      </ul>
      <ul>
        <li>POLLS</li>
        {polls.map((poll) => (
          <li key={poll.id}>{poll.name}</li>
        ))}
      </ul>
    </div>
  );
};

export default inject("overlayStore")(observer(TEST));
